// Поле email для гостей. hCaptcha — Этап 6 (пока строка-плейсхолдер
// «Войди в аккаунт» — для гостей реальная капча подключается позже).
import React from "react";

export default function GuestEmailField({ email, onEmailChange }) {
  return (
    <div>
      <label className="sup-form__label">Твой email (для ответа)</label>
      <input
        className="sup-form__input"
        type="email"
        value={email}
        onChange={(e) => onEmailChange(e.target.value)}
        placeholder="email@example.com"
      />
      <div className="sup-form__hint">
        На этот email МИН пришлёт ответ. Если у тебя есть аккаунт —
        войди, тогда сможешь видеть переписку в кабинете.
      </div>
    </div>
  );
}
